import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin: 20px;
`;

export const SessionTile = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 15px 0;
  width: 100%;
  @media only screen and (max-width: 520px) {
    flex-direction: column;
  }
`;

export const RightTile = styled.div`
  margin-left: 18px;
  padding-left: 18px;
  min-width: 140px;
  border-left: 1px solid ${(props) => props.theme.color.pink};
  font-size: 20px;
  @media only screen and (max-width: 560px) {
    min-width: 120px;
  }
  @media only screen and (max-width: 520px) {
    width: 100%;
    border-left: none;
    border-top: 1px solid ${(props) => props.theme.color.pink};
    margin: 10px 0 0;
    padding: 10px 0 0;
  }
`;

export const Session = styled.div<{ waitingList: boolean }>`
  background-color: ${(props) => props.theme.color.lightPink};
  color: ${(props) => props.theme.color.pink};
  border-radius: 12px;
  margin: 25px 0;
  padding: 0px 20px;
  text-align: center;
  transition: all 200ms ease-in-out;

  ${(props) =>
    props.waitingList &&
    css`
      background-color: ${(props) => props.theme.color.lightBlue};
      color: ${(props) => props.theme.color.darkBlue};
      ${RightTile} {
        border-color: ${(props) => props.theme.color.darkBlue};
      }
    `}

  &:hover, &:focus {
    background-color: ${(props) =>
      props.waitingList ? props.theme.color.darkBlue : props.theme.color.pink};
    color: ${(props) => props.theme.color.white};
    cursor: pointer;
    ${RightTile} {
      border-color: ${(props) => props.theme.color.white};
    }
  }
`;

export const Tile = styled.div`
  max-width: 600px;
  width: 100%;
`;

export const DateTime = styled.div`
  font-weight: bold;
  font-size: 40px;
`;

export const Spaces = styled.div`
  font-weight: 500;
  font-size: 40px;
`;

export const SubText = styled.p`
  margin: 2px;
  font-size: 20px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
